import React from 'react';
import langConf from "../js/lang";

class ShoppingButton extends React.Component {

    handleClick = () => {
        if (!this.props.isDisabled) {
            this.props.updateItemCount(this.props.param2);
            return this.props.onClick(this.props.param);
        }
    }

    handleTableClick = () => {
        if (!this.props.isDisabled) {
            //console.log('handleTableClick called');
            this.props.updateItemCount(this.props.param, this.props.param2);
        }
    }

    render() {
        let disabled = this.props.isDisabled ? 'disabled' : '';
        let lang = this.props.lang;
        if (!this.props.tableView) {
            return (
                <div className={`${this.props.btnClassName} col-6`} onClick={this.handleClick} style={{ display: `${this.props.isVisible ? 'block' : 'none'}` }}>
                    <button className={`btn btn-success btn-block btn-lg ${disabled}`} >{langConf[lang].addToCart}</button>
                </div>

            );
        } else {
            return (
                <div className={`${this.props.btnClassName}`} onClick={this.handleTableClick}>
                    <div className={`btn btn-danger btn-sm ${disabled}`}>
                        <i className={`glyphicon glyphicon-minus`} dir='rtl' style={{ textAlign: 'right' }}></i>
                    </div>
                </div>
            );
        }
    }
}

export default ShoppingButton;
